export default {

  Palette_name_input: {
    width: "100%",
  },

  PNI_save_button: {
    marginRight: "18px",
    marginBottom: "10px",
    height: "30px",
    color: "black"
  },

  PNI_cancel_button: {
    marginRight: "18px",
    marginBottom: "10px",
    height: "30px",
    color: "white"
  }

}